import React, { memo } from "react"
import { Flex, Input, Button } from "antd"
import { SearchOutlined, PlusOutlined, CloseOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import styles from "../index.module.css"

const SearchHeader = memo(({ searchQuery, onSearchChange, onSearchKeyDown, onClearSearch, onAddNewListing, renderSearchResults }) => {
  const { t } = useTranslation()

  return (
    <Flex wrap gap={10} align="center" justify="space-between" className={styles.topSection}>
      <div className={styles.searchContainer}>
        <Input
          className={styles.searchInput}
          placeholder={t("experiences.search_experiences")}
          prefix={<SearchOutlined aria-hidden="true" />}
          suffix={
            searchQuery && (
              <button
                type="button"
                onClick={onClearSearch}
                className="mt-0 cursor-pointer border-0 bg-transparent p-0"
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault()
                    onClearSearch()
                  }
                }}
                aria-label={t("experiences.clear_search")}
              >
                <CloseOutlined aria-hidden="true" />
              </button>
            )
          }
          value={searchQuery}
          onChange={onSearchChange}
          onKeyDown={onSearchKeyDown}
          aria-label={t("experiences.search_experiences")}
          aria-controls="search-results"
          aria-expanded={!!searchQuery}
          aria-autocomplete="list"
          aria-activedescendant={searchQuery ? "search-results" : undefined}
        />
        <section id="search-results" aria-live="polite" aria-labelledby="search-results-heading">
          <h2 id="search-results-heading" className="visually-hidden">
            {t("experiences.search_results")}
          </h2>
          {renderSearchResults()}
        </section>
      </div>
      <Button
        size="large"
        icon={<PlusOutlined aria-hidden="true" />}
        className="ml-auto"
        color="primary"
        variant="solid"
        onClick={onAddNewListing}
      >
        {t("experiences.add_new_listing")}
      </Button>
    </Flex>
  )
})

SearchHeader.displayName = "SearchHeader"

SearchHeader.propTypes = {
  searchQuery: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
  onSearchKeyDown: PropTypes.func.isRequired,
  onClearSearch: PropTypes.func.isRequired,
  onAddNewListing: PropTypes.func.isRequired,
  renderSearchResults: PropTypes.func.isRequired
}

export default SearchHeader
